// extracted by mini-css-extract-plugin
module.exports = {"pageFiance":"Finance_pageFiance_2ni2D","navigation":"Finance_navigation_2HWi1"};